import { t } from "@lingui/macro";
import { Banner } from "@src/components/ui-kit";
import { observer } from "mobx-react-lite";
import type { FunctionComponent } from "react";

type ProjectOverdue = {
  finished: boolean;
  archived: boolean;
};
interface ProjectOverdueBannerProps {
  projectOverdue: ProjectOverdue;
}

const getText = (finished: boolean, archived: boolean) => {
  if (finished && !archived)
    return t`The project is already Finished. Reactivate it to edit`;
  if (finished && archived)
    return t`One of the projects is finished or archived. Reactive it to edit`;
  if (!finished && archived)
    return t`The project is archived. Reactivate it to edit`;
  return "";
};

export const ProjectOverdueBanner: FunctionComponent<ProjectOverdueBannerProps> =
  observer(function ProjectOverdueBanner({ projectOverdue }) {
    return (
      <div className="mb-6">
        <Banner
          status="warning"
          title={
            <div className="flex items-center">
              <h1 className="text-2xl font-bold">
                {getText(projectOverdue.finished, projectOverdue.archived)}
              </h1>
            </div>
          }
        ></Banner>
      </div>
    );
  });
